import React from 'react';
import { NavLink } from 'react-router-dom';
import { useContentful } from '../contentful/ContentContext';

type NavListProps = {
  variant?: 'default' | 'hero';
  size?: 'small' | 'large';
};

// @ts-expect-error
const NavItem = ({ page }) => {
  const isExternalLink = page.fields.url.startsWith('http');
  return (
    <li>
      {isExternalLink ? (
        <a href={page.fields.url} target="_blank" rel="noopener noreferrer">
          {page.fields.pageTitle}
        </a>
      ) : (
        <NavLink to={page.fields.url}>{page.fields.pageTitle}</NavLink>
      )}
    </li>
  );
};

const NavList = ({ variant = 'default', size = 'small' }: NavListProps) => {
  const { getEntriesByType } = useContentful();
  const pages = getEntriesByType('page').sort(
    (a, b) => a.fields.navigationOrder - b.fields.navigationOrder
  );

  return (
    <ul className={`navList navList--${variant} navList--${size}`}>
      {pages.map((page) => (
        <NavItem key={page.sys.id} page={page} />
      ))}
    </ul>
  );
};

export default NavList;
